import { MailboxInfo, MailboxType } from 'owa-client-ids';
import { formatWeekDayDateTime, userDate } from 'owa-datetime';
import { lazyGetRetentionPolicyTagsForGroup } from 'owa-group-utils';
import loc, { format } from 'owa-localize';
import { ClientMessage } from 'owa-mail-store';
import { getRetentionDuration } from 'owa-retention-policies-common';
import RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    infoRetentionPolicyNeverExpire,
    infoRetentionPolicyDetails,
    infoRetentionPolicyDetailsNoDuration,
} from './createPolicyTagInfoBarMessage.locstring.json';

/**
 * This method creates infobar for retention policy tags
 * @param message - message item for which infobar will be created
 */
export default function tryCreatePolicyTagInfoBarMessage(message: ClientMessage): string[] {
    if (shouldShowPolicyTagInfo(message)) {
        const retentionPolicyTag = getRetentionPolicyTag(message);
        if (retentionPolicyTag) {
            const retentionDuration = getRetentionDuration({
                AgeLimitForRetentionDays: retentionPolicyTag.RetentionPeriod,
            });
            const formattedDate =
                message.RetentionDate && retentionPolicyTag.RetentionPeriod != 0
                    ? formatWeekDayDateTime(userDate(message.RetentionDate))
                    : loc(infoRetentionPolicyNeverExpire);
            return retentionDuration
                ? [
                      format(
                          loc(infoRetentionPolicyDetails),
                          retentionPolicyTag.DisplayName,
                          retentionDuration,
                          formattedDate
                      ),
                  ]
                : [
                      format(
                          loc(infoRetentionPolicyDetailsNoDuration),
                          retentionPolicyTag.DisplayName,
                          formattedDate
                      ),
                  ];
        }
    }
    return [];
}

function shouldShowPolicyTagInfo(message: ClientMessage): boolean {
    return !isConsumer() && !!message.PolicyTag;
}

function getRetentionPolicyTag(message: ClientMessage): RetentionPolicyTag {
    const retentionPolicyTags = getRetentionPolicyTagListForMailboxInfo(message.MailboxInfo);
    if (retentionPolicyTags) {
        for (const tag of retentionPolicyTags) {
            if (tag.RetentionId === message.PolicyTag.Value) {
                return tag;
            }
        }
    }
    return null;
}

function getRetentionPolicyTagListForMailboxInfo(mailboxInfo: MailboxInfo) {
    if (mailboxInfo && mailboxInfo.type === MailboxType.GroupMailbox) {
        const getRetentionPolicyTagsForGroup = lazyGetRetentionPolicyTagsForGroup.tryImportForRender();
        return getRetentionPolicyTagsForGroup
            ? getRetentionPolicyTagsForGroup(mailboxInfo.deprecatedMailboxId)
            : [];
    }

    return getUserConfiguration().RetentionPolicyTags;
}
